import { useYearPickerContext } from '@/domain/mitarbeiter/features/feiertagskonto/shared/YearPickerContext';
import { Button } from '@e2n/ui/v2';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function HandleNextYearClick() {
  const { year, setYear } = useYearPickerContext();
  return (
    <Button variant="ghost" onClick={() => setYear(year.add(1, 'year'))}>
      <FontAwesomeIcon
        className="text-neutrals-700 text-xl"
        icon={faChevronRight}
      />
    </Button>
  );
}
